import React, { Component } from "react";
import { connect } from "react-redux";
import CellTempChartWrap from "./wrapper/cell-temp-chart-wrapper";
const mapStateToProps = (state = {}) => {
  return { ...state };
};

// Assuming cellEMSData is the state containing EMS data
class CellTempChart extends Component {

  constructor(props) {
    super(props);

  }


  render() {
    
    var {cellEMSData }= this.props
    var cellTempArr=[]
    var cellNoArr = []
    var cellNo=1;
    if(Object.keys(cellEMSData).length > 0){
    cellEMSData['slaves'].forEach(cellArr => {
      cellArr['cells'].forEach(cell=>{
        cellTempArr.push(cell['t'])
        cellNoArr.push(cellNo)
        cellNo++
      });
    });
    console.log("Each EMS Data through Cell Temp",cellTempArr,cellNoArr)
    return (
      <CellTempChartWrap 
      cellTempArr ={cellTempArr}
      cellNoArr={cellNoArr}
      />
    );
  } else {
    return (<div>No Real Time Cell Temp Data Available</div>)
  }
  }
}
export default connect(mapStateToProps)(CellTempChart);
